import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  y?: number;
};
/**
 * Scroll-triggered fade + rise reveal. Used to sequence sections
 * as the visitor scrolls the long-form sales page.
 */
export function Reveal({
  children,
  className = '',
  delay = 0,
  y = 28
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-362" data-mp="2jqg95uax4u7g">
      {children}
    </motion.div>;
}